export default "__VITE_ASSET__vCJ3aLCw__"